import React, { Component } from 'react';
import Dictionary from '../model/Dictionary';
import { Button } from 'material-ui';
/**
 * ## Redux imports
 */
import * as globalActions from '../redux/actions/GlobalActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../redux/selectors/Index';

class ReservationSuccessfulScreen extends Component {
  render () {
    return (
      <div>
        <h3>{Dictionary.reservationSuccessful.title}</h3>
        <h6>{Dictionary.reservationSuccessful.reservation}</h6>
        <Button variant='raised' color='primary'>
          <a onClick={() => this.props.actions.changeActiveStep('flights')}>
            {Dictionary.reservationSuccessful.print}
          </a>
        </Button>
        <Button variant='raised' color='primary'>
          <a onClick={() => this.props.actions.changeActiveStep('flights')}>
            {Dictionary.reservationSuccessful.continue}
          </a>
        </Button>
      </div>
    );
  }
}

/**
 * ## Redux boilerplate
 */
const actions = [ globalActions ];

function mapStateToProps (state) {
  return { isFetching: selectors.global.isFetching(state.global) };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReservationSuccessfulScreen);



// WEBPACK FOOTER //
// ./src/containers/ReservationSuccessfulScreen.js